import { clsx, type ClassValue } from "clsx";
import { motion } from "motion/react";
import type { ReactNode } from "react";
import type React from "react";

interface SectionSepratorHeaderProps {
  title: string;
  subtitle?: ReactNode;
  description?: ReactNode;
  className?: ClassValue | ClassValue[];
}
const SectionSepratorHeader: React.FC<SectionSepratorHeaderProps> = ({
  title,
  description,
  subtitle,
  className,
}) => {
  return (
    <>
      <div
        className={clsx(
          "px-2.5 md:px-6 mb-16 relative z-10 text-center md:text-left",
          className,
        )}
      >
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="flex items-center gap-4 mb-6 justify-center md:justify-start"
        >
          <div className="w-12 h-px bg-[#4991b8]/30"></div>
          <h1 className="text-[#4991b8] font-bold tracking-[0.6em] uppercase text-[9px]">
            {title}
          </h1>
        </motion.div>
        <h2 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter leading-none mb-4">
          {subtitle}
        </h2>
        <p className="text-zinc-500 font-medium text-lg max-w-xl">
          {description}
        </p>
      </div>
    </>
  );
};

export default SectionSepratorHeader;
